var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGbp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4813 4.96265C1.53869 6.18904 0.827922 7.60255 0.414062 9.13813H6.65678L2.4813 4.96265Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5864 9.13808C23.1725 7.60255 22.4617 6.18904 21.5191 4.96265L17.3438 9.13808H23.5864Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.414062 15.4001C0.827969 16.9357 1.53873 18.3492 2.4813 19.5755L6.65664 15.4001H0.414062Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3063 2.74868C18.0799 1.80607 16.6664 1.0953 15.1309 0.681396V6.92407L19.3063 2.74868Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69531 21.7864C5.9217 22.729 7.33522 23.4398 8.87075 23.8537V17.6111L4.69531 21.7864Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8707 0.681396C7.33517 1.0953 5.92166 1.80607 4.69531 2.74863L8.8707 6.92402V0.681396Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 23.8539C16.6664 23.44 18.0799 22.7292 19.3062 21.7867L15.1309 17.6113V23.8539Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 15.4001L21.5191 19.5756C22.4617 18.3492 23.1725 16.9357 23.5864 15.4001H17.3438Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.7021H13.5653H13.5653V0.368912C13.0529 0.302209 12.5305 0.267334 12 0.267334C11.4694 0.267334 10.9471 0.302209 10.4348 0.368912V10.702V10.7021H0.101578C0.034875 11.2145 0 11.7368 0 12.2673C0 12.7979 0.034875 13.3202 0.101578 13.8325H10.4347H10.4347V24.1658C10.9471 24.2325 11.4694 24.2673 12 24.2673C12.5305 24.2673 13.0529 24.2325 13.5652 24.1658V13.8326V13.8326H23.8984C23.9651 13.3202 24 12.7979 24 12.2673C24 11.7368 23.9651 11.2145 23.8984 10.7021Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 15.4002L20.4857 20.755C20.732 20.5088 20.9669 20.2514 21.191 19.9846L16.6066 15.4001H15.1309V15.4002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87048 15.4001H8.87039L3.51562 20.7549C3.76181 21.0012 4.0192 21.2361 4.28602 21.4603L8.87048 16.8757V15.4001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86878 9.13791V9.13782L3.51397 3.78296C3.26769 4.02915 3.03275 4.28654 2.80859 4.55335L7.39311 9.13787H8.86878V9.13791Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 9.13616L20.4857 3.78126C20.2395 3.53497 19.9821 3.30004 19.7153 3.07593L15.1309 7.66044V9.13616Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGbp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GBP.ea90408c5946ddad501d4cf247daa05a.svg";